import React, { ChangeEvent } from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'
import { colors } from '@lmc/common/constants'
import { FormInput } from '../../../generic'
import { Button, Icon } from '@lmc/ui-kit'

export interface FormProps {
  color: string
  iconText: string
  name: string
}

interface AssessmentEditableHeaderProps {
  form: FormProps
  hasToggle?: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  value?: string
}

interface AssessmentEditableHeaderState {
  hasClickedToggle: boolean
}

export default class AssessmentEditableHeader extends React.Component<
  AssessmentEditableHeaderProps,
  AssessmentEditableHeaderState
> {
  state: AssessmentEditableHeaderState = {
    hasClickedToggle: false
  }

  handleToggleClick = () => {
    this.setState({ hasClickedToggle: true })
  }

  render() {
    const { form, hasToggle, onChange, value } = this.props

    if (!form || !onChange) return null

    const { color, iconText, name } = form
    const isShowingToggle = hasToggle && !this.state.hasClickedToggle

    return (
      <div style={styles.wrapper}>
        <div
          style={{
            background: color,
            ...styles.iconContainer
          }}
        >
          <span style={styles.iconText}>{iconText}</span>
        </div>
        <div
          style={{
            ...styles.titleContainer,
            paddingLeft: iconText ? 15 : 0
          }}
        >
          <div style={styles.textContainer}>
            <span style={styles.title}>{name} for</span>
            {isShowingToggle ? (
              <div style={styles.toggleContainer}>
                <span style={styles.title}>{value}</span>
                <Button
                  className={css(classes.button)}
                  onClick={this.handleToggleClick}
                >
                  <Icon name="EditOutlined" />
                </Button>
              </div>
            ) : (
              <FormInput
                // @ts-ignore
                autoFocus
                className="lmc-sub-card-edit"
                onChange={onChange}
                style={styles.input}
                value={value}
              />
            )}
          </div>
        </div>
      </div>
    )
  }
}

const classes = StyleSheet.create({
  button: {
    background: 'transparent !important',
    position: 'relative',
    top: -1,
    height: 30,
    color: `${colors.black} !important`,
    marginLeft: 6,
    transition: 'all .2s ease',
    ':hover': {
      background: `${colors.orange} !important`,
      color: 'white !important'
    }
  }
})

const styles = {
  divider: {
    height: 2,
    width: '100%'
  },
  iconContainer: {
    alignItems: 'center',
    borderRadius: 4,
    display: 'flex',
    flexShrink: 0,
    height: 40,
    justifyContent: 'center',
    width: 40
  },
  iconText: {
    color: 'white',
    fontSize: 12,
    fontWeight: 'bold'
  },
  input: {
    color: colors.black,
    flex: 1,
    fontSize: 24,
    marginLeft: 5,
    paddingBottom: 2
  },
  textContainer: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontSize: 24,
    minHeight: 37
  },
  titleContainer: {
    flex: 1
  },
  toggleContainer: {
    display: 'flex',
    paddingLeft: 8
  },
  wrapper: {
    display: 'flex',
    width: '100%'
  }
}
